export type Month = {
	month: number;
	name: string;
};

export const Months: any = {
	jan: { month: 0, name: 'jan' },
	feb: { month: 1, name: 'feb' },
	mar: { month: 2, name: 'mar' },
	apr: { month: 3, name: 'apr' },
	may: { month: 4, name: 'may' },
	jun: { month: 5, name: 'jun' },
	jul: { month: 6, name: 'jul' },
	aug: { month: 7, name: 'aug' },
	sep: { month: 8, name: 'sep' },
	oct: { month: 9, name: 'oct' },
	nov: { month: 10, name: 'nov' },
	dec: { month: 11, name: 'dec' },
};
